export default __webpack_public_path__ + "static/swoosh-5171932ec9d44976a7b6000300540cda.png";